import { useParams } from 'react-router-dom';
import { ScoringProvider } from '../../Context/Scoring.context';
import Solution, { SolutionViewMode } from '../Solution/Solution.component';
import useSessionUser from '../../hooks/useSessionUser';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';
import { useState } from 'react';

export const AssessmentSolutionTabs: React.FC = () => {
  const { processTypeId, deskId, examinerFunction } = useParams() as {
    processTypeId: string;
    deskId: string;
    examinerFunction: string;
  };

  const tabExamTaskGroupSolutionScores = useSelector(
    (state: RootState) => state.assessmentSession.tabExamTaskGroupSolutionScores,
  );

  const { userAssessmentSessionInfo } = useSessionUser();

  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
  const [tabIndexesWithUnsavedShelf, setTabIndexesWithUnsavedShelf] = useState<number[]>([]);
  const [isGlobalFullScreen, setIsGlobalFullScreen] = useState<boolean>(false);

  const handleChangeTab = (newValue: number) => setActiveTabIndex(newValue);

  const handleShelfAssessingChange = (value: boolean, tabIndex: number) => {
    if (value) {
      setTabIndexesWithUnsavedShelf([...new Set<number>([...tabIndexesWithUnsavedShelf, tabIndex])]);
    } else {
      setTabIndexesWithUnsavedShelf((prevState) => prevState.filter((item) => item !== tabIndex));
    }
  };

  return (
    <>
      {tabExamTaskGroupSolutionScores.map((tabData, index) => {
        const isTabActive = activeTabIndex === index;
        return (
          <div
            className="screenContainer"
            key={`${tabData.id}_${index}`}
            style={isTabActive ? undefined : { display: 'none' }}
          >
            <ScoringProvider
              orgzId={tabData.id}
              examinerId={tabData.examinerId}
              assessmentSessionId={userAssessmentSessionInfo.assessmentSessionId}
              processTypeId={processTypeId}
              deskId={deskId}
              examinerFunction={examinerFunction}
              isTabView={true}
            >
              <Solution
                mode={SolutionViewMode.assessment}
                isTabActive={isTabActive}
                activeTabIndex={activeTabIndex}
                onChangeTab={handleChangeTab}
                tabs={tabExamTaskGroupSolutionScores}
                tabIndexesWithUnsavedShelf={tabIndexesWithUnsavedShelf}
                onShelfAssessingChange={(value) => handleShelfAssessingChange(value, index)}
                isGlobalFullScreen ={isGlobalFullScreen}
                onFullScreenChange={setIsGlobalFullScreen}
              />
            </ScoringProvider>
          </div>
        );
      })}
    </>
  );
};
